export type SkeletonProps = {
  children?: React.ReactElement | null;
  width?: number | string;
  height?: number | string;
  style?: React.CSSProperties;
};

/* Responsive skeleton component that can wrap any element to automatically copy its sizing  */
export function Skeleton({
  children = null,
  width,
  height,
  style = {},
}: SkeletonProps) {
  return (
    <div
      style={{
        display: "flex",
        position: "relative",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        pointerEvents: "none",
        overflow: "hidden",
        height: height,
        width: width,
        ...style,
      }}
    >
      {children}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          borderRadius: "4px",
          zIndex: 1,
          backgroundColor: "#434D61",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            width: "100%",
            height: "100%",
            background:
              "linear-gradient(90deg, rgba(190, 190, 190, 0.4) 25%, rgba(255, 255, 255, 0.36) 37%, rgba(190, 190, 190, 0.4) 63%)",
            backgroundSize: "400% 100%",
            animation: "skeleton-loading 0.75s ease infinite",
            content: "",
          }}
        />
      </div>
      <style>{`
        @keyframes skeleton-loading {
          0% {
            background-position: 100% 50%;
          }
          100% {
            background-position: 0 50%;
          }
        }
      `}</style>
    </div>
  );
}
